export default importAll = (req) =>
  req.keys().forEach(req)
